import React, { Component } from 'react';
import { Form, Button, Col, Container,Row } from 'react-bootstrap';
import { endPoints } from "../../constant/Environment";
class ActionListSearch extends Component{

    exportCsv = (e) => {
        e.preventDefault();
        var body = {
            userId: 0,
            startdate: "",
            enddate: ""
        }
        fetch(`${endPoints.apiBaseUrl+endPoints.api.ACTION_REPORT+'/csv'}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = 'ActionListReport.csv';
                        link.click();
                    })
                   
                });
    };
    exportPdf = (e) => {
        e.preventDefault();
        var body = {
                userId: 0,
                startdate: "",
                enddate: ""
        }
        fetch(`${endPoints.apiBaseUrl+endPoints.api.ACTION_REPORT+'/pdf'}`, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                }).then(function(response) {
                    response.blob().then(blob => {
                        const link = document.createElement('a');
                        const url = URL.createObjectURL(blob);
                        console.log(url);
                        link.href = url;
                        link.download = 'ActionListReport.pdf';
                        link.click();
                    })
                });
    };

    render() {
        return( <Container fluid>
                    <Form>
                    <Row>
                   
   <Col>
                            <Form.Group as={Col} controlId="formFirstName">
                                <Form.Label className="label">Name</Form.Label>
                                <Form.Control
                                type="text"
                              
                                name="firstName"
                                required
                              
                                />
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="formLastName">
                                <Form.Label className="label">User Name</Form.Label>
                                <Form.Control
                                type="text"                           
                                name="lastName"
                                required
                           
                                />
                            </Form.Group>
                            </Col>
                            <Col>
                            <Form.Group as={Col} controlId="formLastName">
                                <Form.Label className="label">Resister Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="date"
                                required
                           
                                />
                            </Form.Group>
                            </Col>
                       

                        <Col>
                        <Form.Group as={Col} controlId="formLastName">
                                <Form.Label className="label">Start Date</Form.Label>
                                <Form.Control
                                type="date"                           
                                name="date"
                                required
                           
                                />
                            </Form.Group>
                            </Col>  
                            {/* <Col></Col>  */}
                        </Row>
                        
                        <Row>
                        {/* <Col></Col> */}
                        
                        
                        {/* <Col></Col>       */}
   <Col>
   <Button className='exportbtn' onClick={this.exportPdf}>
   <img src="/images/icons/pdf.png" />
   </Button>
   <Button className='exportbtn' onClick={this.exportCsv}>
   <img src="/images/icons/csv.png" />
   </Button> </Col>
   <Col>
                        <Button variant="primary" onClick={this.saveAndContinue}>Search</Button>
                        
                        <Button variant="primary" className='mrglft10' onClick={this.saveAndContinue}>Add</Button>
                        </Col>
                        <Col></Col>
                        <Col></Col>
                        </Row>
                    </Form>
                </Container>
        );
    }
}

export default ActionListSearch;